import { useEffect } from "react";

export const TYPE_BASE_SIZES = {
  "--type-micro": 12,
  "--type-caption": 14,
  "--type-body": 16,
  "--type-subheading": 18,
  "--type-heading": 22,
  "--type-display": 28,
};

export const FONT_SCALE_MESSAGE = "SET_FONT_SCALE";
export const FONT_SCALE_REQUEST_MESSAGE = "REQUEST_FONT_SCALE";

const postScaleToFrames = (scale) => {
  document.querySelectorAll("iframe").forEach((frame) => {
    frame.contentWindow?.postMessage(
      { type: FONT_SCALE_MESSAGE, payload: scale },
      "*",
    );
  });
};

const SCALED_UI_SIZES = {
  // Preserve the existing native scaling behavior for icons and spacing.
  "--icon-size-xs": 12,
  "--icon-size-sm": 14,
  "--icon-size-md": 16,
  "--icon-size-lg": 20,
  "--icon-size-xl": 24,
  "--icon-size-xxl": 32,
  "--icon-size-36": 36,
  "--icon-size-40": 40,
  "--icon-size-48": 48,
  "--icon-size-56": 56,
  "--icon-size-64": 64,

  // Spacing (scaled with font)
  "--spacing-1": 4,
  "--spacing-2": 8,
  "--spacing-3": 12,
  "--spacing-4": 16,
  "--spacing-5": 20,
  "--spacing-6": 24,
};

const useFontScale = () => {
  useEffect(() => {
    const handleMessage = (event) => {
      let data = event.data;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // Ignore parse errors
          return;
        }
      }

      if (data?.type === FONT_SCALE_REQUEST_MESSAGE) {
        event.source?.postMessage?.(
          {
            type: FONT_SCALE_MESSAGE,
            payload: window.__seniorLifeFontScale || 1,
          },
          "*",
        );
        return;
      }

      if (data?.type === FONT_SCALE_MESSAGE) {
        const scale = parseFloat(data.payload);
        if (!isNaN(scale)) {
          window.__seniorLifeFontScale = scale;
          document.documentElement.style.setProperty("--font-scale", scale);
          Object.entries({ ...TYPE_BASE_SIZES, ...SCALED_UI_SIZES }).forEach(
            ([key, baseSize]) => {
              const newSize = `${baseSize * scale}px`;
              document.documentElement.style.setProperty(key, newSize);
            },
          );
          postScaleToFrames(scale);
        }
      }
    };

    // Add event listeners for both window and document (to support various WebView implementations)
    window.addEventListener("message", handleMessage);
    document.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      document.removeEventListener("message", handleMessage);
    };
  }, []);
};

export default useFontScale;
